import { Action } from "./action";
import { TweenLite } from "gsap";
export class CustomAction extends Action {
    constructor(callback) {
        super();
        this._callback = callback;
    }
    start() {
        this._callback();
        this.completeEvent.raise();
    }
    stop() { }
}
export class TestCaseLogAction extends Action {
    constructor(testCase, message) {
        super();
        this._testCase = testCase;
        this._message = message;
    }
    start() {
        super.start();
        this._testCase.log(this._message);
        this._completeEvent.raise();
    }
    stop() {
        super.stop();
        //Do nothing you really can't stop this.
    }
}
export class TestCaseExceptionAction extends Action {
    constructor(testCase, error) {
        super();
        this._testCase = testCase;
        this._error = error;
    }
    start() {
        super.start();
        this._testCase.erroredEvent.raise(this._error);
        this._completeEvent.raise();
    }
    stop() {
        super.stop();
        //Do nothing you really can't stop this.
    }
}
export class EnableAction extends Action {
    constructor(object, enabled) {
        super();
        this._object = object;
        this._enabled = enabled;
    }
    start() {
        this._object.enabled = this._enabled;
        this._completeEvent.raise();
    }
    stop() {
        //Do nothing you really can't stop this.
    }
}
export class DelayAction extends Action {
    constructor(milliseconds) {
        super();
        this._tween = null;
        this._milliseconds = milliseconds;
    }
    start() {
        this._tween = TweenLite.to({}, this._milliseconds / 1000, { onComplete: () => this._onComplete() });
    }
    _onComplete() {
        this._completeEvent.raise();
    }
    stop() {
        if (this._tween !== null) {
            this._tween.kill();
            this._tween = null;
            this._onComplete();
        }
    }
}
export class NullAction extends Action {
    constructor() {
        super();
    }
    start() {
        this._completeEvent.raise();
    }
    stop() {
        //Do nothing you really can't stop this.
    }
}
export class MoveToAction extends Action {
    constructor(object, endX, endY, durationMilliseconds) {
        super();
        this._tween = null;
        this._object = object;
        this._endX = endX;
        this._endY = endY;
        this._durationMilliseconds = durationMilliseconds;
    }
    start() {
        this._tween = TweenLite.to(this._object, this._durationMilliseconds / 1000, { x: this._endX, y: this._endY, onComplete: () => this._onComplete() });
    }
    _onComplete() {
        this._completeEvent.raise();
    }
    stop() {
        if (this._tween !== null) {
            this._tween.kill();
            this._tween = null;
            this._onComplete();
        }
    }
}
